const Title = ({ text} ) => {
    return(
    <h1 className="mobile:max-w-80 small:max-w-screen-mobile desktop:max-w-full mobile:text-4xl small:text-4xl desktop:text-7xl text-center uppercase font-title bg-gradient-white bg-clip-text text-transparent">{text}</h1>
    )
}

export default Title;